import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import landscapeData from '../../content/landscape.json';

const ImpactGBS: React.FC = () => {
  const { impact } = landscapeData;
  const [isVisible, setIsVisible] = useState(true);

  // Auto-hide after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.section
        initial={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="py-4 relative overflow-hidden"
      >
      {/* Background gradient */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%)',
          opacity: 0.3,
        }}
      />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Apple macOS 26 Liquid Glass - Exact Specifications */}
          <div
            className="overflow-hidden"
            style={{
              /* Core glass effect - Apple official values */
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px) saturate(180%)',
              WebkitBackdropFilter: 'blur(10px) saturate(180%)',

              /* Borders and shadows - Layered system */
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '16px',
              boxShadow: '0 8px 32px rgba(31, 38, 135, 0.2), inset 0 4px 20px rgba(255, 255, 255, 0.3)',

              /* Performance optimization */
              willChange: 'backdrop-filter',
            }}
          >
            <div className="p-4 flex items-start gap-3">
              <div className="text-2xl flex-shrink-0">🎁</div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-gray-900 mb-1">
                  Give Back to Society (GBS)
                </h3>
                <p className="text-xs text-gray-700 leading-snug">
                  {impact.gbs}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </motion.section>
    </AnimatePresence>
  );
};

export default ImpactGBS;
